import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Staking from "@/pages/staking/Staking.vue";
import MazeMaker from "@/pages/mazeMaker/MazeMaker.vue";
import Maze from "@/pages/maze/Maze.vue";
const routes: Array<RouteRecordRaw> = [
  { path: "/", component: Maze },
  { path: "/mazeMaker", component: MazeMaker },
  { path: "/maze", component: Maze },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
